import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { svgDataUrl } from "ui/components/elements/icons/vacuum-pump";
var cupPath = "M37.8902 16.7525L52.2462 34.6976L1.99999 34.6976L16.3561 16.7525M37.8902 16.7525L37.8902 2.39648L16.3561 2.39648L16.3561 16.7525M37.8902 16.7525L16.3561 16.7525";
export var CupIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 27 : _b, _c = _a.height, height = _c === void 0 ? 18 : _c;
    return (_jsx("svg", { width: width, height: height, viewBox: "0 0 55 37", fill: "none", children: _jsx("path", { d: cupPath, stroke: "white", strokeWidth: "3.73", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
/* The cup centred in a square, so it can be drawn on a square texture. */
var SquareCupIcon = function (_a) {
    var size = _a.size, color = _a.color;
    return (_jsx("svg", { width: size, height: size, viewBox: "0 -9 55 55", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: cupPath, stroke: color, strokeWidth: "3.73", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
/**
 * The cup as a square SVG data URL, for drawing it as a PlayCanvas texture
 * (see `vacuumPumpIconDataUrl`).
 */
export var cupIconDataUrl = function (size, color) {
    return svgDataUrl(_jsx(SquareCupIcon, { size: size, color: color }));
};
